import * as React from 'react';
export const IcCalf = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M18.75 8h-.82c-.45-3.66-3.38-5-5.93-5S6.52 4.34 6.07 8h-.82A2.25 2.25 0 003 10.25a.76.76 0 00.75.75h1.5c.3.002.596-.06.87-.18a25.6 25.6 0 00.48 2.61c.06.27.12.53.17.78A5 5 0 0110 13h4a5 5 0 013.23 1.21c.05-.25.11-.51.17-.78.205-.861.365-1.732.48-2.61.274.12.57.182.87.18h1.5a.76.76 0 00.75-.75A2.25 2.25 0 0018.75 8zM9 11a1 1 0 110-2 1 1 0 010 2zm6 0a1 1 0 110-2 1 1 0 010 2zm-1 4h-4a3 3 0 000 6h4a3 3 0 000-6z'
      fill='currentColor'
    />
  </svg>
);
